<template lang="html">
  <div>
    <md-layout md-flex="100">
      <h1>Actualiza tus datos</h1>
      <h3>
        Por Favor Actualiza tus datos; estos son de suma importancia para la elaboracion de tus facturas, Cuida sobretodo tu Regimen Fiscal y tu Codigo Postal, ya que si estos datos son incorrectos tu factura será invalida
      </h3>
    </md-layout>
    <md-layout md-gutter="16" md-flex="100" md-flex-small="100" md-flex-xsmall="100" class="whiteframe">
      <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
        <md-input-container>
          <label>Nombre Fiscal</label>
          <md-input v-model="cliente.cliente.nombre"></md-input>
        </md-input-container>
      </md-layout>

      <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
        <md-input-container>
          <label>Nombre Comercial</label>
          <md-input v-model="cliente.cliente.comercial"></md-input>
        </md-input-container>
      </md-layout>

      <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
        <md-input-container>
          <label>Email</label>
          <md-input v-model="cliente.cliente.email"></md-input>
        </md-input-container>
      </md-layout>
      
      <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
        <md-input-container>
          <label>Telefono</label>
          <md-input v-model="cliente.cliente.telefono"></md-input>
        </md-input-container>
      </md-layout>
      
      <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
        <md-input-container>
          <label>Dirección</label>
          <md-input v-model="cliente.cliente.direccion"></md-input>
        </md-input-container>
      </md-layout>
      
      <md-layout md-flex="25" md-flex-small="50" md-flex-xsmall="50">
        <md-input-container>
          <label>Número Exterior</label>
          <md-input v-model="cliente.cliente.numext"></md-input>
        </md-input-container>
      </md-layout>
      
      <md-layout md-flex="25" md-flex-small="50" md-flex-xsmall="50">
        <md-input-container>
          <label>Número interior</label>
          <md-input v-model="cliente.cliente.numint"></md-input>
        </md-input-container>
      </md-layout>
      
      <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
        <md-input-container>
          <label>Colonia</label>
          <md-input v-model="cliente.cliente.colonia"></md-input>
        </md-input-container>
      </md-layout>
      
      <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
        <md-input-container>
          <label>Ciudad</label>
          <md-input v-model="cliente.cliente.poblacion"></md-input>
        </md-input-container>
      </md-layout>
      
      <md-layout md-flex="50" md-flex-small="50" md-flex-xsmall="50">
        <md-input-container>
          <label>Estado</label>
          <md-input v-model="cliente.cliente.entfed"></md-input>
        </md-input-container>
      </md-layout>
      <md-layout md-flex="50" md-flex-small="50" md-flex-xsmall="50">
        <md-input-container>
          <label>CP</label>
          <md-input v-model="cliente.cliente.cp"></md-input>
        </md-input-container>
      </md-layout>
      <md-layout md-flex="100" style="border-bottom: 1px solid #ccc"></md-layout>
        <h3>Actualizar Regimen Fiscal</h3>
        <md-layout md-flex="100" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
                <label for="Regimen">Regimen Fiscal</label>
                <md-select tabindex="4" required name="Regimen" id="Regimen" v-model="cliente.cliente.RegimenFiscalSAT">
                <md-option :value="regimen.clave" :key="regimen.idinterno" v-for="regimen in regimenFiscaldata">{{regimen.clave}} - {{regimen.descripcion}}</md-option>
                </md-select>
                <span class="md-error">Requerido</span>
            </md-input-container>
        </md-layout>
        <md-layout md-flex="100" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
                <label for="Regimen">USO CFDI</label>
                <md-select tabindex="4" required name="Regimen" id="Regimen" v-model="cliente.cliente.UsoCfdiSat">
                <md-option :value="regimen.clave" :key="regimen.idinterno" v-for="regimen in usoCFDI">{{regimen.clave}} - {{regimen.descripcion}}</md-option>
                </md-select>
                <span class="md-error">Requerido</span>
            </md-input-container>
        </md-layout>
        <md-layout md-flex="100">
          <md-checkbox id="my-test1" name="my-test1" v-model="cliente.cliente.campo_n_1">Confirmo que los datos aquí ingresados son verídicos</md-checkbox>
        </md-layout>
        <md-layout>
          <md-layout md-flex="100">
            <h2>Constancia Regimen Fiscal</h2><br><br>
          </md-layout>
          <md-layout md-flex="100">
            <p>Por favor sube tu constancia de regimen fiscal</p>
          </md-layout>
          <md-layout>
            <div class="container">
              <div class="large-12 medium-12 small-12 cell">
                <label
                  >File
                  <input
                    type="file"
                    id="file"
                    ref="file"
                    v-on:change="handleFileUpload()"
                  />
                </label>
                <button v-on:click="submitFile()" class="boton">Subir Archivo</button>
              </div>
              <md-spinner md-indeterminate v-show="spin"></md-spinner>
            </div>
          </md-layout>
        </md-layout>

        <md-layout md-flex="100" md-align="end">
          <md-button class="md-primary md-raised" :disabled="!cliente.cliente.campo_n_1 === true" id="entrar" @click.native="changeRegimen">
            Actualizar Datos
            
          </md-button>        
        </md-layout>

      <md-layout md-flex="100" style="border-bottom: 1px solid #ccc"></md-layout>

      <md-layout md-flex="100">
        <md-input-container>
          <label>Contraseña anterior</label>
          <md-input required type="password" v-model="contrasena"></md-input>
        </md-input-container>
      </md-layout>

      <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
        <md-input-container>
          <label>Contraseña</label>
          <md-input required type="password" v-model="contrasenaNueva"  @blur.native="checkPassword"></md-input>
        </md-input-container>
      </md-layout>
      
      <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
        <md-input-container :class="isPasswordEqual">
          <label>Confirma Contraseña</label>
          <md-input required type="password" v-model="confirmaContrasena" @blur.native="checkPassword"></md-input>
        </md-input-container>
        <span class="md-error" v-if="!passwordEqual">
          Las contraseñas no coinciden
        </span>
      </md-layout>

      <md-layout md-flex="100" md-align="end">
        <md-button :disabled="!passwordEqual" class="md-primary md-raised" id="entrar" @click.native="changePass">
          Cambiar Contraseña
          <md-tooltip v-if="!passwordEqual">
            Las contraseñas deben coincidir
          </md-tooltip>
        </md-button>        
      </md-layout>
    </md-layout>
  </div>
</template>

<script type="text/javascript">
import getBasePath from '../../common/functions/api-resource';

export default {
  name: 'Pedidos',
  data() {
    return {
      basePath: getBasePath('api', 'v1'),
      resourceCliente: this.$api.cliente(this.$resource),
      cliente: {},
      regimenFiscaldata:[],
      usoCFDI:[],
      passwordEqual: false,
      contrasena: '',
      contrasenaNueva: '',
      spin:false,
      confirmaContrasena: ''
    };
  },
  computed: {
    isPasswordEqual() {
      return this.passwordEqual ? '' : 'md-input-invalid';
    },
  },
  components: {
  },
  methods: {
    submitFile() {
      if(this.file){

        var self = this;
        // var vmm = vm;
          let formData = new FormData();
          // this.showImagen = false;
          this.spin = true;
          formData.append("file", this.file);
          axios
            .post(
              this.basePath + "/clientes/Constancia/" + this.cliente.cliente.idinterno,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then(function () {
              alert("El Archivo se subio correctamente");
              self.spin = false;
              self.changeRegimen();
            })
            .catch(function () {
              self.spin = false;
              console.log("FAILURE!!");
            });
      } else {
        alert('no ha seleccionado ningun archivo');
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    changePass () {
      const data = {
        contrasena: this.contrasena,
        contrasenaNueva: this.contrasenaNueva
      };
      this.resourceCliente.changePassword({ idcliente: this.cliente.idinterno }, data)
          .then((response) => {
            this.$toast.create('La contraseña se cambio correctamente', 'snack', 3E3);            
          })
          .catch((err) => {
            this.$toast.create('Ocurrio un error', 'snack', 3E3);
          });
    },
    checkPassword() {
      this.passwordEqual =
        this.contrasenaNueva === this.confirmaContrasena;
    },
    goToCatalogo() {
      this.$router.push({ name: 'inicio' });
    },
    changeRegimen(){
      if(this.cliente.cliente.RegimenFiscalSAT === null || this.cliente.cliente.RegimenFiscalSAT === '' || this.cliente.cliente.RegimenFiscalSAT === undefined){
        alert('Por favor ingresa tu regimen fiscal')
      } else {
        if(this.cliente.cliente.UsoCfdiSat === null || this.cliente.cliente.UsoCfdiSat === '' || this.cliente.cliente.UsoCfdiSat === undefined){
          alert('Por favor ingresa el uso CFDI');
        } else {
          if(this.cliente.cliente.cp === null || this.cliente.cliente.cp === '' || this.cliente.cliente.cp === undefined){
          alert('Por favor ingresa el CP');
        } else {

          const data = {
            regimen: this.cliente.cliente.RegimenFiscalSAT,
            nombre: this.cliente.cliente.nombre,
            comercial: this.cliente.cliente.comercial,
            telefono: this.cliente.cliente.telefono,
            direccion: this.cliente.cliente.direccion,
            numext: this.cliente.cliente.numext,
            numint: this.cliente.cliente.numint,
            colonia: this.cliente.cliente.colonia,
            poblacion: this.cliente.cliente.poblacion,
            entfed: this.cliente.cliente.entfed,
            cp: this.cliente.cliente.cp,
            email: this.cliente.cliente.email,
            UsoCfdiSat: this.cliente.cliente.UsoCfdiSat,
            autorizacion: this.cliente.cliente.campo_n_1

          };
          this.resourceCliente.changeRegimen({ idcliente: this.cliente.cliente.idinterno }, data)
              .then((response) => {
                debugger
                window.cliente = this.cliente;
                localStorage.setItem('cliente', JSON.stringify(this.cliente));

                this.$toast.create('Los datos se actualizaron correctamente', 'snack', 3E3);            
              })
              .catch((err) => {
                this.$toast.create('Ocurrio un error', 'snack', 3E3);
              });
          }
        }
      }
    },
    getRegimenFiscal(){
      this.resourceCliente.getRegimenFiscal()
          .then((response) => {
            this.regimenFiscaldata = response.data;
          })
          .catch((err) => {
            this.$error(this, err);
          });
    },
    getUsoCFDI(){
      this.resourceCliente.getUsoCFDI()
          .then((response) => {
            this.usoCFDI = response.data;
          })
          .catch((err) => {
            this.$error(this, err);
          });
    }
  },
  mounted() {
    this.cliente = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')) : null;
    if (this.cliente === null){
      this.goToCatalogo();
    }
    this.getRegimenFiscal();
    this.getUsoCFDI();
  },
};
</script>

<style lang="scss">
.md-error{
  color: #EF5350;
  font-size: 12px;
  margin-top: -25px;
}
.boton{
  min-width: 88px;
    min-height: 36px;
    margin: 6px 8px;
    padding: 0 16px;
    display: inline-block;
    position: relative;
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    outline: none;
    background: none;
    border: 0;
    border-radius: 2px;
    -webkit-transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    color: currentColor;
    font-family: inherit;
    font-size: 14px;
    font-style: inherit;
    font-variant: inherit;
    font-weight: 500;
    letter-spacing: inherit;
    line-height: 36px;
    text-align: center;
    text-transform: uppercase;
    text-decoration: none;
    vertical-align: top;
    white-space: nowrap;
    // -webkit-box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
    // box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
    background-color: #009688;
    color: rgba(255, 255, 255, .87);


}

</style>



// WEBPACK FOOTER //
// src/spa/perfil/Perfil.vue